import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./reviews.css"

const responsive = {
  hires: {
    breakpoint: { max: 3000, min: 1921 },
    items: 4
    //slidesToSlide: 1 // optional, default to 1.
  },
  desktop: {
    breakpoint: { max: 1920, min: 1024 },
    items: 3
    //slidesToSlide: 1 // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 2
    //slidesToSlide: 1 // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 767, min: 0 },
    items: 1
    //slidesToSlide: 1 // optional, default to 1.
  }
};

//ignore-ts
// const customRight = ({ onClick, ...rest }) => {
//   // const {
//   //   onMove,
//   //   carouselState: { currentSlide, deviceType }
//   // } = rest;
//   // onMove means if dragging or swiping in progress.
//   return <button /*title=">" */ onClick={() => onClick()} />;
// };

class Reviews extends React.Component {

    render() {

      const { data } = this.props;
      console.log("datalog", data);

      return (
        <Carousel
          responsive={responsive}
          arrows={true}
          autoPlay={false}
          infinite={true}
          containerClass="carousel-container"
          itemClass="carousel-item-padding-40-px"
        >
            {data.data.allReviews.nodes.map(items => (
              <div className="review-wrap greybg" key={items.id} style={{ height: "250px", backgroundColor: "rgb(214, 214, 214)" }}>
                <div className="reviewerName">{items.reviewerName}</div>
                <div className="starRating"><span role="img" aria-label="5 out of 5 Stars">⭐⭐⭐⭐⭐</span></div>
                <div className="reviewDate">{items.reviewDate}</div>
                <div className="reviewProduct">
                  {
                    items.reviewProduct ?
                      <section dangerouslySetInnerHTML={{ __html: items.reviewProduct}} />
                    :
                      <section/>
                  }
                </div>
                <div className="reviewContent"><section dangerouslySetInnerHTML={{ __html: items.reviewContent}} /></div>
              </div>
            ))}
      </Carousel>
      );
    }
}

export default Reviews;
